import set from 'lodash/set';

export class ValidationError extends Error {
  errors: Record<string | number, unknown>;

  constructor({
    message,
    errors = [],
  }: {
    message?: string;
    errors?: { message: string; path: string | string[] }[];
  } = {}) {
    super(message);

    // C10: nest errors by their dot-joined / array path so that Formik's
    // setErrors can inline them on the correct nested field (e.g.
    // ['data','source','params','limit'] → data.source.params.limit).
    // The dead Mongoose `Path \`x\`` prefix-replace has also been removed —
    // Zod issues never carry that prefix.
    const nested: Record<string | number, unknown> = {};
    for (const { message: msg, path } of errors ?? []) {
      const normalizedPath = Array.isArray(path) ? path.join('.') : path;
      if (normalizedPath) {
        set(nested, normalizedPath, msg);
      } else {
        // top-level error (empty path) — store under a sentinel key
        nested['_error'] = msg;
      }
    }
    this.errors = nested;
  }

  hasErrors() {
    return Object.keys(this.errors).length > 0;
  }
}
